import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { styled } from '@mui/material/styles';
import { Button, Card, CssBaseline, Stack, Typography } from '@mui/material';
import Banner from '../components/feature-specific/Banner';
import { useLocation, useNavigate } from 'react-router-dom';
// Styled Components
const StyledCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    marginTop: "0px",
    maxWidth: '450px',
    boxShadow: 'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
}));

const StatusListItem = styled('li')<{ status: number }>(({ status, theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0),
    borderRadius: '8px',
    backgroundColor: (status) ? '#e8f5e9' : '#fff3cd', // Green for success, yellow for pending
    color: status === 1 ? '#4caf50' : '#856404', // Text color
    fontWeight: 500,
}));

const Summary: React.FC = () => {
    const location = useLocation();
    const {aadharNameMatch,panNameMatch,bankNameMatch} = location.state || {};

    const navigate = useNavigate();

    interface statusResponse{
        aadhar: number;
        pan: number;
        bank:number;
    }
    
    const handleFinishClick=()=>{
        navigate('/finish');
    }

    return (
        <>
            <Banner/>
        <StyledCard>
            <CssBaseline enableColorScheme/>
            <Typography variant="h4" color="black" sx={{ textAlign: 'center' }}>Thank You</Typography>
            <Typography variant="h5" color="black">Your response has been recorded successfully</Typography>
            <Typography variant="h6" color="black">Verification Status:</Typography>
            <Stack component="ul" spacing={2} sx={{ padding: 0 }}>
            <StatusListItem status={panNameMatch}>
            <strong>PAN</strong>
            <span>{panNameMatch ? 'Verified ' : 'Pending'}</span>
            </StatusListItem>
            <StatusListItem status={aadharNameMatch}>
            <strong>Aadhar</strong>
            <span>{aadharNameMatch ? 'Verified ' : 'Pending'}</span>
            </StatusListItem>
            <StatusListItem status={bankNameMatch}>
            <strong>Bank</strong>
            <span>{bankNameMatch ? 'Verified ' : 'Pending'}</span>
            </StatusListItem>
            </Stack>
            {(bankNameMatch&&aadharNameMatch&&panNameMatch)?<></>:
            <>
                <Typography variant="body2" sx={{ marginTop: 2, color: 'black' }}>
                                Pending: Verification will be done manually.
                </Typography>
            </>
            }
            <Button variant='contained' onClick = {handleFinishClick}>
                Finish
            </Button>
        </StyledCard>
        </>
    );
};

export default Summary;
